import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'
import Style from './MenuProduct.module.css'

const MenuProduct = ({click=true,index='2',...props}) => {
    const type=localStorage.getItem('type')
    return (
        <ul className={Style.menuItemHolder}> 
                { 
                type==="supermarket"?
                <div className={Style.addsHolder}>
                    <Link className={Style.addProduct} to={"/addproductsupermarket"}><FontAwesomeIcon icon={faPlus} className={Style.plusIcon}/> محصول</Link>
                    {/* <div className={Style.addProduct} onClick={props.openModalHandle}><FontAwesomeIcon icon={faPlus} className={Style.plusIcon} /> محصول</div> */}
                    <Link className={Style.addProduct} to={"/addbrandsupermarket"}><FontAwesomeIcon icon={faPlus} className={Style.plusIcon}/> برند</Link>
                </div>
                :
                <Link className={Style.addProduct} to={"/addproductrestaurant"}><li className={Style.PlusIconHolder}><FontAwesomeIcon icon={faPlus} className={Style.plusIcon}/> محصول</li></Link>
                }
            {
                props.data.slice(0).reverse().map(item=>
                    <li key={item.id} 
                    className={click && index===item.id ? Style.different : Style.menuItem } 
                    onClick={()=>props.categoryHandle(item.id)}
                    > {item.category}</li>
                    )
            }
        </ul>
    )
}
export default MenuProduct
